var map = {
	"./arrow-down.svg": 7770,
	"./arrow.svg": 1885,
	"./check.svg": 6574,
	"./facebook.svg": 946,
	"./flickr.svg": 2411,
	"./foursquare.svg": 8203,
	"./google-plus.svg": 524,
	"./instagram.svg": 5142,
	"./linkedin.svg": 3832,
	"./magnifier.svg": 9274,
	"./nav-hamburger.svg": 2255,
	"./pinterest.svg": 2404,
	"./snapchat.svg": 8104,
	"./tumblr.svg": 5068,
	"./twitter.svg": 7439,
	"./user.svg": 6431,
	"./vimeo.svg": 8862,
	"./whatsapp.svg": 656,
	"./youtube.svg": 7125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3310;